













































































































































/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// axios请求
import { baseSentryInfo, baseSentryAddOrEdit } from '@/api/parking-lot-management/index';
// 引入组件
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@root/utils/common';
import value from '*.json';
import { trim } from '@root/utils/validators';
// form表单项定义
export interface IForm {
  name: string; //岗亭名称
  code: string; //岗亭名称
  parkId: string; //车场id
  type: string; //岗亭类型
  sentryVersion: string; //岗亭版本号
  description: string; //备注
  parkName: string;
}
@Component({
  name: 'createAndEdit',
  components: { ParkingLotSearch }
})
export default class createAndEdit extends Vue {
  @Prop()
  dataForm!: any;
  @Prop({ type: Boolean, default: false })
  isEdit!: boolean;
  // 表单
  form: any = null;
  spinning = false;
  // 岗亭类型
  sentryTypeOptions: IOption[] = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.sentry_type);
  @Watch('dataForm', { deep: true })
  dataChanged(val: any) {
    if (val) {
      this.init();
    }
  }
  // 表单布局
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };
  /**
   * 初始化form表单
   */
  init() {
    if (this.isEdit && this.dataForm) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { id, name, code, parkName, type, sentryVersion, description, parkId } = this.dataForm;
          return {
            name: this.$form.createFormField({
              value: name
            }),
            code: this.$form.createFormField({
              value: code
            }),
            parkName: this.$form.createFormField({
              value: parkName
            }),
            parkId: this.$form.createFormField({
              value: parkId
            }),
            type: this.$form.createFormField({
              value: type
            }),
            sentryVersion: this.$form.createFormField({
              value: sentryVersion
            }),
            description: this.$form.createFormField({
              value: description
            })
          };
        }
      });
    } else {
      // 新增状态
      this.form = this.$form.createForm(this);
    }
  }
  // 提交监听处理
  async handleSubmit(e: any) {
    e.stopPropagation();
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        this.spinning = true;
        this.onAddOrEdit({ ...values });
      }
    });
  }
  // 添加和编辑
  async onAddOrEdit(values: IForm) {
    try {
      const res = await baseSentryAddOrEdit({
        ...values,
        ...(this.isEdit ? { id: this.dataForm.id } : {})
      });
      this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
      this.form.resetFields();
      this.$emit('ok', {});
    } catch (e) {
      this.$message.error((e && e.msg) || `${this.isEdit ? '编辑' : '新增'}失败`);
      console.log(e);
    } finally {
      this.spinning = false;
    }
  }
  //表单取消
  cancelForm() {
    // if (this.isEdit) {
    //   this.form.resetFields(['name', 'type', 'sentryVersion', 'description'])
    // } else {
    //   this.form.resetFields()
    // }
    this.$emit('ok');
    this.form.resetFields();
  }
  created() {
    this.init();
  }
}
